import { reducerFromMap } from "../../libs/helpers/reducers";

import {
  OTHER_CATEGORIES_LOADING,
  OTHER_CATEGORIES_LOADED,
  OTHER_CATEGORIES_LOAD_ERROR,
  OTHER_CATEGORIES_CREATE_LOADING,
  OTHER_CATEGORIES_CREATE_LOAD_ERROR,
  OTHER_CATEGORIES_EDIT_LOADING,
  OTHER_CATEGORIES_EDIT_COMPLETE,
  OTHER_CATEGORIES_EDIT_LOAD_ERROR,
  OTHER_CATEGORIES_DELETE_LOADING,
  OTHER_CATEGORIES_DELETE_COMPLETE,
  OTHER_CATEGORIES_DELETE_LOAD_ERROR,
  OTHER_CATEGORIES_CREATE_COMPLETE,
} from "../../actions/registry/registry.other_categories.actions";

const reducer = {
  /*
   * OTHER_CATEGORIES LIST
   */
  [OTHER_CATEGORIES_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [OTHER_CATEGORIES_LOADED]: (state, { data }) => ({
    ...state,
    loading: false,
    data: data.data,
  }),
  [OTHER_CATEGORIES_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * OTHER_CATEGORIES CREATE
   */
  [OTHER_CATEGORIES_CREATE_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [OTHER_CATEGORIES_CREATE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [OTHER_CATEGORIES_CREATE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * OTHER_CATEGORIES EDIT
   */
  [OTHER_CATEGORIES_EDIT_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [OTHER_CATEGORIES_EDIT_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [OTHER_CATEGORIES_EDIT_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * OTHER_CATEGORIES DELETE
   */
  [OTHER_CATEGORIES_DELETE_LOADING]: (state) => ({
    ...state,
    other_categories: { ...state.other_categories, loading: true },
  }),
  [OTHER_CATEGORIES_DELETE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [OTHER_CATEGORIES_DELETE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    other_categories: { ...state.other_categories, loading: false },
    error: data,
  }),
};

export default reducerFromMap(reducer, {
  data: [],
});
